import { useIntl } from 'react-intl'
import { UNKNOWN_ERROR_CONTENT } from '../constants'
import { ErrorContentType, MaybeErrorData } from '../types/errorTypes'
import { isAPIErrorType, parseErrorOutput } from '../utils'

export const useAPIErrorContent = (
  errorData: MaybeErrorData
): ErrorContentType => {
  const { formatMessage } = useIntl()

  if (errorData) {
    const error = errorData.error

    // is error coming from API?
    if (isAPIErrorType(error)) {
      const output = parseErrorOutput(error)
      const errorCode = output.statusCode

      return {
        errorHeader: `${errorCode}`,
        errorText: `${errorCode} ${formatMessage({
          id: 'common.commonErrors.' + errorCode
        })}`
      }
    }
  }

  return UNKNOWN_ERROR_CONTENT
}
